import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import { i18n } from "services/i18nService";
import { exchangeShopifyToken } from "services/sosInventoryService/sosApi";

import { openAlert } from "globalState/alertSlice";
import {
  loadingIndicatorOn,
  loadingIndicatorOff,
} from "globalState/loadingSlice";

const DEFAULT_LINK_ERROR = i18n("shopify.ConnectError");

export function ShopifyAuth() {
  const { search } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    function handleError(authError) {
      navigate("/configuration/list/cart", { state: { authError } });
    }

    async function _exchangeShopifyToken(params) {
      dispatch(loadingIndicatorOn());
      try {
        const { success, message } = await exchangeShopifyToken(params);
        if (success) {
          // Clear the stored state on success
          sessionStorage.removeItem("shopify_oauth_state");
          // Extract cartId from state (format: nonce_cartId)
          const cartId = state?.split("_")[1];
          dispatch(
            openAlert({
              type: "success",
              message: i18n("shopify.ConnectSuccess"),
            })
          );
          navigate(
            cartId
              ? `/configuration/list/cart/${cartId}`
              : "/configuration/list/cart"
          );
        } else {
          handleError(message || DEFAULT_LINK_ERROR);
        }
        dispatch(loadingIndicatorOff());
      } catch (e) {
        dispatch(loadingIndicatorOff());
        handleError(DEFAULT_LINK_ERROR);
      }
    }

    const queryParams = new URLSearchParams(search);
    const storedState = sessionStorage.getItem("shopify_oauth_state");
    const state = queryParams.get("state");
    const code = queryParams.get("code");
    const shop = queryParams.get("shop");
    const hmac = queryParams.get("hmac");
    const host = queryParams.get("host");
    const timestamp = queryParams.get("timestamp");

    if (state !== storedState) {
      handleError(i18n("shopify.SecurityValidationFailed"));
    } else if (code && shop) {
      _exchangeShopifyToken({ code, shop, state, hmac, timestamp, host });
    } else {
      handleError(DEFAULT_LINK_ERROR);
    }
  }, [navigate, search, dispatch]);

  return null;
}
